module.exports = __webpack_public_path__ + "static/media/swap.97e760ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Pair/scenes/Amount/img/swap.svg
// module id = 183
// module chunks = 0